import { ChevronRight, Menu } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useRole } from '../lib/compte'
import { EnteteSection } from '../ui/composants/entete-section'
import { ENTREES_PLUS } from '../ui/entrees'
import { LiensLegaux } from '../ui/liens-legaux'

/** Onglet « Plus » : les écrans qui n'ont pas leur onglet. */
export default function Plus() {
  const role = useRole()
  return (
    <main className="flex flex-1 flex-col gap-4 p-4">
      <EnteteSection Icone={Menu} titre="Plus" description="Tous vos autres outils." />
      <ul className="flex flex-col gap-2">
        {ENTREES_PLUS.filter((e) => !e.proprietaire || role === 'proprietaire').map(({ to, titre, description, Icone, couleur }) => (
          <li key={to}>
            <Link to={to} className="flex min-h-14 items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3 shadow-sm active:bg-slate-50">
              <span className={`flex size-10 shrink-0 items-center justify-center rounded-xl text-white ${couleur}`}>
                <Icone aria-hidden className="size-5" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-bold">{titre}</span>
                <span className="block text-sm text-slate-700">{description}</span>
              </span>
              <ChevronRight aria-hidden className="size-5 shrink-0 text-slate-500" />
            </Link>
          </li>
        ))}
      </ul>
      <LiensLegaux className="pt-2" />
    </main>
  )
}
